import { ActionTypes } from './constants';
import * as Models from './models';

export const setDocumentTypes: Models.ActionCreator.SetDocumentTypes = documentTypes => ({
  type: ActionTypes.SET_DOCUMENT_TYPES,
  payload: {
    documentTypes,
  },
});
